export const toggleArrayItem = (array, value) => {
    let index = array.indexOf(value);
  
    if (index === -1) {
        array.push(value);
    } else {
        array.splice(index, 1);
    }
  
    return array;
  }